var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"recom"},[_vm._v("单点登录中，请稍后...")])])])
}]

export { render, staticRenderFns }